// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"0b2b1976","805":"9104dd07","843":"eab3515c"}[chunkId] + ".chunk.js";
};